import { MdDashboard, MdStorefront, MdPublish, MdLockOpen, MdDesignServices } from 'react-icons/md';
import type { IconType } from 'react-icons';

import { TypePermission } from '../../infra/types';

const ROTA_DO_DESIGNER = '/designer';

export type AppShellNavItem = {
  path: string;
  label: string;
  icon: IconType;
  /** Menor tipoUsuario que vê o item no menu e abre a rota pela URL. */
  nivelMinimo: TypePermission;
  exact?: boolean;
};

export const navItems: AppShellNavItem[] = [
  {
    path: '/',
    label: 'Dashboard',
    icon: MdDashboard,
    nivelMinimo: TypePermission.usuario,
    exact: true,
  },
  {
    path: '/store',
    label: 'Loja',
    icon: MdStorefront,
    nivelMinimo: TypePermission.administradorPainel,
  },
  {
    path: '/publications',
    label: 'Publicações',
    icon: MdPublish,
    nivelMinimo: TypePermission.administradorPainel,
  },
  {
    path: '/permissions',
    label: 'Liberações',
    icon: MdLockOpen,
    nivelMinimo: TypePermission.administradorPainel,
  },
  {
    path: ROTA_DO_DESIGNER,
    label: 'Designer',
    icon: MdDesignServices,
    // Abaixo de editor, só com o Designer liberado na sessão (ver podeAcessarRota).
    nivelMinimo: TypePermission.administradorPainel,
  },
];

// Rota fora do menu (ex.: /viewer-preview) continua liberada para qualquer usuário autenticado.
export function nivelMinimoDaRota(path: string): TypePermission {
  return navItems.find((item) => item.path === path)?.nivelMinimo ?? TypePermission.usuario;
}

// tipoUsuario vem do localStorage: ausente ou inválido cai no nível mais baixo.
// designerCliente vem do login (claim funcionarioInside): sem ele, o OnPremises
// da unidade é anterior ao Designer do cliente e recusaria o administrador.
export function podeAcessarRota(
  path: string,
  tipoUsuario: unknown,
  designerCliente?: boolean
): boolean {
  const nivel = Number(tipoUsuario);
  const nivelDoUsuario = Number.isFinite(nivel) ? nivel : TypePermission.usuario;

  if (nivelDoUsuario < nivelMinimoDaRota(path)) return false;

  return (
    path !== ROTA_DO_DESIGNER || nivelDoUsuario >= TypePermission.editor || designerCliente === true
  );
}
